import { render, staticRenderFns } from "./evaluations-table.vue?vue&type=template&id=355457d4&"
import script from "./evaluations-table.vue?vue&type=script&lang=js&"
export * from "./evaluations-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports